import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { EVENT_TYPE_FILTERS, type EventTypeFilter } from '../../../core/utils/event-category.util';

@Component({
  selector: 'app-category-navigation',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './category-navigation.component.html',
})
export class CategoryNavigationComponent {
  activeCategory = input<EventTypeFilter>('Alle');
  categoryChanged = output<EventTypeFilter>();

  readonly categories: EventTypeFilter[] = EVENT_TYPE_FILTERS;

  selectCategory(category: EventTypeFilter): void {
    this.categoryChanged.emit(category);
  }

  isActive(category: EventTypeFilter): boolean {
    return this.activeCategory() === category;
  }
}
